// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3-w8c","col":"styles_col__1lfZh"};